import { render, staticRenderFns } from "./cookingDetail.vue?vue&type=template&id=34897a36&scoped=true&"
import script from "./cookingDetail.vue?vue&type=script&lang=js&"
export * from "./cookingDetail.vue?vue&type=script&lang=js&"
import style0 from "./cookingDetail.vue?vue&type=style&index=0&id=34897a36&scoped=true&lang=css&"
import style1 from "./cookingDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34897a36",
  null
  
)

export default component.exports